import React, { useEffect, useMemo, useState } from "react";
import { Card, CardBody } from "reactstrap";
import CountUp from "react-countup";
import FeatherIcon from "feather-icons-react";
import CardWidgetSkeleton from "Components/Common/CardWidgetSkeleton";
import { CurrencyFormat, formatCurrencySuffix } from "common/lib/currency";
import { getYearDateRange } from "common/lib/dateUtils";
import { getTotalPaymentsAmount } from "common/services/payments.service";
import useQueryState from "Components/Hooks/UseQueryState";
import { useProfile } from "Components/Hooks/UserHooks";

const TotalSupport = () => {
  const { userProfile } = useProfile();
  const [loading, setLoading] = useState(false);
  const [totalActiveSupport, setTotalActiveSupport] = useState(0);
  const [totalSupport, setTotalSupport] = useState<CurrencyFormat>({
    amount: 0,
    suffix: "",
    formattedString: "",
    exactAmount: 0,
  });

  const [selectedYear] = useQueryState(
    "year",
    new Date().getFullYear().toString()
  );
  const { firstDay, lastDay } = getYearDateRange(Number(selectedYear));

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        const response: any = await getTotalPaymentsAmount({
          agencyId: userProfile?.agency?.id,
          startDate: firstDay,
          endDate: lastDay,
        });
        setTotalSupport(formatCurrencySuffix(response?.totalAmount));
      } catch (error) {
        console.warn("Error fetching total active support", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [firstDay, lastDay, userProfile?.agency?.id]);

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        const response: any = await getTotalPaymentsAmount({
          agencyId: userProfile?.agency?.id,
          startDate: firstDay,
          endDate: lastDay,
          active: true,
        });
        setTotalActiveSupport(response?.totalAmount);
      } catch (error) {
        console.warn("Error fetching total active support", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [firstDay, lastDay, userProfile?.agency?.id]);

  const percentageValue = useMemo(() => {
    if (totalSupport.exactAmount === 0) return 0;
    return (totalActiveSupport / totalSupport?.exactAmount) * 100;
  }, [totalActiveSupport, totalSupport]);

  if (loading) {
    return <CardWidgetSkeleton />;
  }
  console.log("Total Active Support", totalActiveSupport);
  console.log("Total Support", totalSupport);
  return (
    <Card className="card-animate mb-4 card-bottom-primary">
      <CardBody className="">
        <div className="d-flex justify-content-between">
          <div>
            <p className="fw-medium text-muted mb-0">Total Support</p>
            <h2 className="mt-4 ff-secondary cfs-22 fw-semibold">
              <span className="counter-value">
                <CountUp
                  start={0}
                  end={totalSupport?.amount}
                  decimals={1}
                  duration={4}
                />
              </span>
              {totalSupport?.suffix}
            </h2>
            <p className="mb-0 text-muted text-truncate">
              <span className="badge bg-light text-success mb-0 me-2">
                {percentageValue.toFixed(2)} %
              </span>
              currently active
            </p>
          </div>
          <div>
            <div className="avatar-sm flex-shrink-0">
              <span className="avatar-title bg-info-subtle rounded-circle fs-2">
                <FeatherIcon icon="dollar-sign" className="text-success" />
              </span>
            </div>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default TotalSupport;
